/**
 * Espelha a janela de recuperação automática aplicada pelo job diário
 * `retry-error-batches` no backend (YELUM_ERROR_RETRY_WINDOW_MS).
 */
export const ERROR_RETRY_WINDOW_DAYS = 7;

const ERROR_RETRY_WINDOW_MS = ERROR_RETRY_WINDOW_DAYS * 24 * 60 * 60 * 1000;

export interface BatchErrorRetryInput {
  isManualProcessing: boolean;
  lastErrorRetryable?: boolean | null;
  firstErrorAt?: string | null;
  lastErrorAt?: string | null;
}

/**
 * Indica se o lote em ERROR ainda será reprocessado automaticamente pelo job
 * diário, contando a janela a partir da primeira falha da sequência.
 */
export function willBatchAutoRetry(batch: BatchErrorRetryInput): boolean {
  if (batch.isManualProcessing || batch.lastErrorRetryable !== true) {
    return false;
  }

  const anchor = batch.firstErrorAt || batch.lastErrorAt;
  if (!anchor) {
    return true;
  }

  const anchorTime = new Date(anchor).getTime();
  if (Number.isNaN(anchorTime)) {
    return true;
  }

  return Date.now() - anchorTime <= ERROR_RETRY_WINDOW_MS;
}
